import {
    getAction,
    deleteAction,
    putAction,
    postAction
} from '../http'

export default {

    list(params = {}) {
        return getAction('/api/design/viewUserDepart/list', params);
    },

    //查询用户
    getUsers: (params = {}) => getAction('/api/design/sysUser/list', params)
}